import React from 'react';
import {Box, Typography} from "@mui/material";
import {DigitizationMetadataWrapper} from "./DigitizationMetadata.styled";
import {useTranslation} from "react-i18next";
import {tokens} from "../../../../../theme";

interface DigitizationMetadataProps {
    dataRows: { label: string; value: string | React.ReactNode }[];
}

const DigitizationMetadata = ({dataRows}: DigitizationMetadataProps) => {
    const {t} = useTranslation();
    return (
        <DigitizationMetadataWrapper>
            <Typography variant="h6">
                {t('digitizationDetails.metadata.title')}
            </Typography>

            <Box display="flex" flexDirection="column" gap={2}>
                {dataRows.map((row, index) => (
                    <Box key={index}
                         display="flex"
                         justifyContent="space-between"
                         alignItems="center"
                         gap={1}
                         sx={{ flexWrap: 'wrap'}}
                    >
                        <Typography sx={{flex: 1}} color="secondary">
                            {row.label}
                        </Typography>

                        <Box sx={{
                            display: 'flex',
                            fontSize: tokens.fontSize.base,
                            flex: 1,
                            ml: '2px',
                            justifyContent: 'flex-end',
                            wordBreak: 'break-word'
                        }}>
                            {row.value}
                        </Box>
                    </Box>
                ))}
            </Box>
        </DigitizationMetadataWrapper>
    );
};

export default DigitizationMetadata;